module.exports = require("remarkable");


//////////////////
// WEBPACK FOOTER
// external "remarkable"
// module id = 271
// module chunks = 0